import { Button, Modal } from '@paysense-india-services/elevate-web'

import { getImageUrl } from '@/constants/images'

import { PAYMENT_STATUS_CONFIG } from './constants'

const PaymentStatusModal = ({ status, show, onClose, onCtaClick }) => {
  const config = PAYMENT_STATUS_CONFIG[status?.toLowerCase()]

  if (!config) return null

  return (
    <Modal elevation='200' onOverlayClick={onClose} show={show} showCross={false}>
      <div className='ew-d-flex ew-flex-column ew-gap-8 ew-pt-8'>
        <img alt='' height={48} src={getImageUrl(config.icon)} width={48} />
        <div className='ew-d-flex ew-flex-column ew-gap-4'>
          <div className='ew-typography-extra-large ew-fw-bold ew-color-primary'>
            {config.title}
          </div>
          <div
            className='ew-typography-normal ew-color-secondary ew-fw-regular'
            style={{ whiteSpace: 'pre-line' }}>
            {config.description}
          </div>
        </div>
        <div className='ew-py-16'>
          <Button fullWidth onClick={onCtaClick} size='large' type='button' variant='brand'>
            <div className='ew-typography-normal ew-fw-semi-bold'>{config.ctaText}</div>
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default PaymentStatusModal
